import React from 'react'

const Content = ({ children, ...rest }) => {
  return <div {...rest}>{children}</div>
}

export default Content
